import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {Moment} from 'moment';
import {EntityLinkedToAccountWithAuditMetadata} from '../../../../common/entity/entityLinkedToAccountWithAuditMetadata';
import {PartnerSummaryModel} from '../../../../partner/common/api/model/partnerSummary.model';
import {ReportDefinitionModel} from '../../../report-definition/api/entity/reportDefinition.model';
import {ReportDefinitionSummaryModel} from '../../../report-definition/api/entity/reportDefinitionSummary.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class ReportSummaryModel extends EntityLinkedToAccountWithAuditMetadata implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    label: string;
    date: Moment;
    partner: PartnerSummaryModel;
    reportDefinition: ReportDefinitionSummaryModel;
    status: LovValueSummary;
}
